import React from 'react'
import Modal from 'react-modal'
import { ModalStyles } from './ModalStylesObj'

export const ModalAsDropdown = ({ isModalVisible, toggleModal, modalContent, customModalStyles }) => (
    <Modal
        isOpen={isModalVisible}
        onRequestClose={toggleModal}
        style={customModalStyles || ModalStyles}
        ariaHideApp={false}
    >
        {modalContent()}
    </Modal>
)
